import { createContext } from "react";
const dictContext = createContext({});
export const DictContextProvider = dictContext.Provider;
export const DictContextConsumer = dictContext.Consumer;
//# sourceMappingURL=DictContext.js.map